import React from "react";
import "./SupportProjectPage.css";

export default function SupportProjectPage() {
  const contacts = [
    {
      type: "Phone",
      detail: "+231 881 924 553",
      icon: "📞",
      action: "tel:+231881924553"
    },
    {
      type: "Email",
      detail: "info@ugaaliberia.org",
      icon: "✉️",
      action: "info@ugaaliberia.org"
    },
    {
      type: "Materials",
      detail: "Drop off at UGAA Liberia Office, Office Address: 1st Floor Sekou House Capitol Bye Pass Adjacent BMC Stores",
      icon: "📦",
      action: "#"
    },
    {
      type: "Cash / Pledge",
      detail: "Bank or Mobile Money – Ask committee for details",
      icon: "💰",
      action: "#"
    }
  ];

  return (
    <div className="support-page">
      {/* HERO */}
      <section className="support-hero">
        <h1>Support Our Projects</h1>
        <p>
          Interested in supporting any of our projects? Contact the Project Committee directly.
        </p>
      </section>

      {/* CONTACT CARDS */}
      <section className="support-contact-section">
        <div className="support-contact-grid">
          {contacts.map((c, idx) => (
            <a
              href={c.action}
              key={idx}
              className="support-contact-card"
            >
              <div className="support-contact-icon">{c.icon}</div>
              <h3 className="support-contact-type">{c.type}</h3>
              <p className="support-contact-detail">{c.detail}</p>
            </a>
          ))}
        </div>
      </section>
    </div>
  );
}
